import { defineComponent as y, inject as _, computed as o, getCurrentInstance as g, openBlock as E, createElementBlock as O, withModifiers as S, normalizeClass as h, unref as l, renderSlot as x, createElementVNode as V, toDisplayString as w } from "vue";
import { optionProps as B } from "./option.js";
import { useNamespace as D } from "../../hooks/use-namespace.js";
import "../../hooks/use-z-index.js";
import "./option.css";
import "../select/index.js";
import { selectContextKey as K } from "../select/select.js";
const P = /* @__PURE__ */ y({
  __name: "option",
  props: B,
  emits: ["click"],
  setup(u, { emit: p }) {
    const e = u, m = p, s = D("option"), n = _(K), c = o(() => Object.prototype.toString.call(e.value).toLowerCase() === "[object object]"), d = g().proxy;
    n.onOptionCreate(d);
    const v = (t, r) => {
      if (c.value) {
        const { valueKey: a } = n.props;
        return !!t && !!r && t[a] === r[a];
      } else
        return t === r;
    }, f = o(() => v(e.value, n.props.modelValue)), b = o(() => e.label || (c.value ? "" : e.value)), i = o(() => e.value || e.label || ""), C = () => {
      e.disabled;
    }, k = () => {
      n.changeEvent(i.value), m("click", i.value);
    }, j = o(() => e.disabled);
    return (t, r) => (E(), O("li", {
      class: h([
        l(s).b(),
        l(s).is("selected", f.value),
        l(s).is("disabled", j.value)
      ]),
      onMouseenter: C,
      onClick: S(k, ["stop"])
    }, [
      x(t.$slots, "default", {}, () => [
        V("span", null, w(b.value), 1)
      ])
    ], 34));
  }
});
export {
  P as default
};
